exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-5b5514b8]{background-color:transparent;border:0;padding:.7em .55em .45em;position:absolute;right:0;text-transform:uppercase;top:.73em}@media (min-width:45em){button[data-v-5b5514b8]{display:none}}button[data-v-5b5514b8]:hover{background-color:rgba(0,0,0,.1)}button svg[data-v-5b5514b8]{display:block;height:26.4px;pointer-events:none;width:26.4px}.is-open button svg[data-v-5b5514b8]{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b5514b8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./sportspower/assets/es6/components/MenuButton.vue
// module id = 38
// module chunks = 0